import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Bell notifications from the chat (LC5) link to `/stores/<store>/inbox/<conversation>`, the
 * backend's link shape; this forwards them to the inbox thread.
 */
export const Route = createFileRoute('/_authed/_active/stores/$storeId/inbox/$conversationId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/inbox/$storeId/$conversationId',
      params: { storeId: params.storeId, conversationId: params.conversationId },
      replace: true,
    });
  },
});
